import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { getFullDate } from '../../utils/dateTimeUtil';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../contexts/languageContext';
import MessagesContext from '../../contexts/messagesContext';
import { EditIcon, TrashIcon } from '../UI/Images/Icons';
import { CalendarInput } from '../UI';
const styles = makeStyles((theme) => ({
    mainInfo: (props) => ({
        position: 'absolute',
        top: '-13px',
        direction: props.rtl ? 'rtl' : 'ltr',
        right: props.rtl ? '21.33px' : 'auto',
        left: props.rtl ? 'auto' : '21.33px',
        background: '#fff',
        fontSize: '14px',
        zIndex: '10',
        display: 'flex',
        justifyContent: 'space-between'
    }),
    drName: ({ rtl }) => ({
        // minWidth: '100px',
        textAlign: rtl ? 'right' : 'left',
        whiteSpace: 'nowrap'
    }),
    actions: {
        flex: '1',
        '& > svg': {
            width: '20px',
            height: '20px',
            margin: '0 8px',
            cursor: 'pointer'
        }
    },
    drugsContainer: {},
    datePickerContainer: {
        position: 'relative',
        // [theme.breakpoints.up(1025)]: {
        '& > div:nth-of-type(1)': {
            width: 'unset',
            padding: 'unset'
        }
        // }
    },
    datePicker: {
        width: '95px',
        border: 'solid 0.5px #bbbbbb ',
        borderRadius: '4px',
        lineHeight: '30px',
        fontSize: '16px',
        textAlign: 'center',
        fontFamily: 'inherit',
        '&:focus': {
            border: 'solid 1px #1b90fa'
        }
    },
    drWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        flex: '1',
        // margin: '0 10px',
        '& > div': {
            margin: '0 10px'
        },
        [theme.breakpoints.down(1025)]: {
            flexWrap: 'wrap'
        }
    },

    datePickerLabel: (props) => ({
        fontSize: '12px',
        display: 'block',
        position: 'absolute',
        bottom: '100%',
        right: props.rtl ? '0' : 'auto',
        left: props.rtl ? 'auto' : '0',
        padding: '5px 0',
        color: 'rgba(118,118,118,0.8)'
    })
}));
const mobileStyles = makeStyles({
    mobileMainInfo: (props) => ({
        direction: props.rtl ? 'rtl' : 'ltr',
        background: '#f5f6fa',
        fontSize: '14px',
        display: 'flex',
        justifyContent: 'space-between',
        marginRight: '40px',
        marginLeft: '24px',
        padding: '6px 15px 4px',
        borderRadius: '6px',
        position: 'sticky',
        left: '24px',
        alignItems: 'center'
    }),
    mobileDatePicker: {
        border: 'none',
        borderBottom: 'solid 1px #ced2d6',
        background: 'transparent',
        width: '75px',
        fontFamily: 'mainFont',
        fontSize: '14px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.07',
        letterSpacing: 'normal',
        color: '#232733'
    }
});
const PrescriptionHeader = ({
    prescriber,
    prescribed,
    addNew,
    editable,
    setEditable,
    handleChangeDate,
    handleDelete,
    isMobile,
    notEditClinical
}) => {
    const { lang } = useContext(LanguageContext);
    const { messages } = useContext(MessagesContext);
    const classes = styles({ rtl: lang === 'fa' });
    const mobileClasses = mobileStyles({ rtl: lang === 'fa' });
    const [date, setDate] = useState(prescribed ? prescribed : null);
    const handleChange = (value) => {
        setDate(value);
        handleChangeDate(value);
    };
    const renderPrescriber = () => {
        if (prescriber && prescriber.last_name) {
            return (
                <div className={classes.drName} data-testid="drName">
                    {messages.dr} {prescriber.first_name + ' ' + prescriber.last_name}
                </div>
            );
        }
        return null;
    };
    if (editable || addNew) {
        return (
            <div className={isMobile ? mobileClasses.mobileMainInfo : classes.mainInfo}>
                <div className={classes.drWrapper}>
                    <div className={classes.datePickerContainer}>
                        {addNew && !isMobile && (
                            <label className={classes.datePickerLabel}>{messages.date}</label>
                        )}
                        <CalendarInput
                            customClasses={
                                isMobile ? mobileClasses.mobileDatePicker : classes.datePicker
                            }
                            usePortal
                            value={date}
                            setValue={handleChange}
                        />
                    </div>
                    {renderPrescriber()}
                </div>
            </div>
        );
    } else {
        return (
            <div className={isMobile ? mobileClasses.mobileMainInfo : classes.mainInfo}>
                <div className={classes.drWrapper}>
                    <div>{getFullDate(prescribed)}</div>
                    <div>{renderPrescriber()}</div>
                </div>

                <div className={classes.actions}>
                    <EditIcon
                        fill={'#416ce1'}
                        width={'20px'}
                        height={'20px'}
                        data-testid="editIcon"
                        disabled={notEditClinical}
                        onClick={() => !notEditClinical && setEditable(true)}
                    />
                    <TrashIcon
                        width={'20px'}
                        height={'20px'}
                        data-testid="trashIcon"
                        disabled={notEditClinical}
                        onClick={handleDelete}
                    />
                </div>
            </div>
        );
    }
};
PrescriptionHeader.propTypes = {
    prescriber: PropTypes.object,
    prescribed: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    addNew: PropTypes.bool,
    editable: PropTypes.bool,
    setEditable: PropTypes.func,
    handleChangeDate: PropTypes.func,
    handleDelete: PropTypes.func,
    isMobile: PropTypes.bool,
    notEditClinical: PropTypes.bool
};
export default PrescriptionHeader;
